import { BaseFilter, SortDirection } from '../sort/sort';

export class LabelFilter extends BaseFilter {
  name: string;
  scope: string;
  text: string;

  constructor(
    name: string,
    scope: string,
    text: string,
    sortProperties: string[],
    sortDirection: SortDirection,
    pageNumber: number = 0,
    pageSize: number = 20
  ) {
    super(sortProperties, sortDirection, pageNumber, pageSize);
    this.name = name;
    this.scope = scope;
    this.text = text;
  }
}
